module.exports = __webpack_public_path__ + "static/img/navigation.be7a4e08.png";